// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor, setMixedChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let tot = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001730')}`, //Total
			align: 'right',
			minWidth: '100px',
			fixed: true,
			custom: true,
			sortable: false
		};

		let mmScn = {
			label: `${rootGetters['commonStore/getMessage_']('MWPP000165')}`, //대분류
			prop: 'mmScn',
			align: 'left',
			minWidth: '120px',
			fixed: true,
			sortable: false
		};
		let scn = {
			label: `${rootGetters['commonStore/getMessage_']('MWPP000167')}`, //중분류
			prop: 'scn',
			align: 'left',
			minWidth: '120px',
			fixed: true,
			sortable: false
		};
		cols.push(mmScn);
		cols.push(scn);
		cols.push(tot);

		let startMonth = state.searchParams.strtMm01;
		let endMonth = state.searchParams.endMm01;
		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');
		let qtVal1 = false;
		let qtVal2 = false;
		let qtVal3 = false;
		let qtVal4 = false;

		if (state.searchParams.mmPrvs === '10') {
			// console.log('getter mmPrvs 변함	::', state.searchParams.mmPrvs);
			tot.prop = 'mmTot';
			tot.labelClassName = 'mmTot';

			let propI = 1;
			for (let i = strMo; i < strMo + diffMonth + 1; i++) {
				const year = strYr + Math.floor(i / 12);
				const month = (i % 12) + 1;
				const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
				let pclProp = 'mm' + setLpad(propI, 2, '0');
				const newCol = {
					label: labelYear + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
					prop: pclProp,
					minWidth: '100px',
					align: 'right',
					custom: true,
					labelClassName: labelYear + setLpad(month, 2, '0')
				};
				propI++;
				cols.push(newCol);
			}
		} else if (state.searchParams.mmPrvs === '20') {
			//console.log('getter mmPrvs 변함	::', state.searchParams.mmPrvs);
			let qtVal = moment(startMonth).quarter();
			//console.log('qtVal	::', qtVal);
			//console.log('diffMonth	::', diffMonth);
			let qtqt = Math.floor(diffMonth / 3);
			//console.log('qtqt	::', qtqt);

			tot.prop = 'qtTot';
			tot.labelClassName = 'qtTot';
			let propI = 1;
			let newCol;
			for (let i = strMo; i < strMo + diffMonth + 1; i++) {
				const year = strYr + Math.floor(i / 12);
				const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
				const month = (i % 12) + 1;
				let pclProp = 'qt' + setLpad(propI, 2, '0');

				if (month == 1 || month == 2 || month == 3) {
					if (qtVal1 === false) {
						newCol = {
							label: labelYear + ' 01Qt',
							prop: pclProp,
							minWidth: '100px',
							align: 'right',
							clickEvent: (arg1, arg2, arg3) => console.log('click yess', arg1, arg2, arg3),
							//custom: true,
							labelClassName: labelYear + '01Qt'
						};
						cols.push(newCol);
						propI++;
						qtVal1 = true;
					} else {
					}
				} else if (month == 4 || month == 5 || month == 6) {
					if (qtVal2 === false) {
						newCol = {
							label: labelYear + ' 02Qt',
							prop: pclProp,
							minWidth: '100px',
							align: 'right',
							clickEvent: () => console.log('click yess'),
							//custom: true,
							labelClassName: labelYear + '02Qt'
						};
						cols.push(newCol);
						propI++;
						qtVal2 = true;
					} else {
					}
				} else if (month == 7 || month == 8 || month == 9) {
					if (qtVal3 === false) {
						newCol = {
							label: labelYear + ' 03Qt',
							prop: pclProp,
							minWidth: '100px',
							align: 'right',
							clickEvent: () => console.log('click yess'),
							//custom: true,
							labelClassName: labelYear + '03Qt'
						};
						cols.push(newCol);
						propI++;
						qtVal3 = true;
					} else {
					}
				} else if (month == 10 || month == 11) {
					if (qtVal4 === false) {
						newCol = {
							label: labelYear + ' 04Qt',
							prop: pclProp,
							minWidth: '100px',
							align: 'right',
							clickEvent: () => console.log('click yess'),
							//custom: true,
							labelClassName: labelYear + '04Qt'
						};
						cols.push(newCol);
						propI++;
						qtVal4 = true;
					} else {
					}
				} else if (month == 12) {
					if (qtVal4 === false) {
						newCol = {
							label: labelYear + ' 04Qt',
							prop: pclProp,
							minWidth: '100px',
							align: 'right',
							clickEvent: () => console.log('click yess'),
							//custom: true,
							labelClassName: labelYear + '04Qt'
						};
						cols.push(newCol);
						propI++;
					} else {
					}
					qtVal1 = false;
					qtVal2 = false;
					qtVal3 = false;
					qtVal4 = false;
				}
			}
		} else {
			//console.log('getter mmPrvs 변함	::', state.searchParams.mmPrvs);
			tot.prop = 'yyTot';
			tot.labelClassName = 'yyTot';
			let endYr = moment(endMonth).year();
			let diffYears = moment(endYr).diff(strYr);
			let propI = 1;
			for (let i = strYr; i < strYr + diffYears + 1; i++) {
				const labelYear = i + `${rootGetters['commonStore/getMessage_']('QWCC001451')}`;
				//console.log('labelYear	::', labelYear);
				let pclProp = 'yy' + setLpad(propI, 2, '0');
				const newCol = {
					label: labelYear,
					prop: pclProp,
					minWidth: '100px',
					align: 'right',
					custom: true,
					labelClassName: labelYear
				};
				propI++;
				cols.push(newCol);
			}
		}
		//console.log('매칭값', cols);
		return cols;
	},
	LineChartLabel_: (state, getters, rootState, rootGetters) => {
		// let cols = [];

		// let startMonth = state.searchParams.strtMm01;
		// let endMonth = state.searchParams.endMm01;
		// let strYr = moment(startMonth).year();
		// let strMo = moment(startMonth).month();
		// let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		// let propI = 1;
		// for (let i = strMo; i < strMo + diffMonth + 1; i++) {
		// 	const year = strYr + Math.floor(i / 12);
		// 	const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		// 	const month = (i % 12) + 1;
		// 	const label = labelYear + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
		// 	propI++;
		// 	cols.push(label);
		// }

		// return cols;

		let cols = [];

		let startMonth = state.searchParams.strtMm01;
		let endMonth = state.searchParams.endMm01;
		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		let qtVal1 = false;
		let qtVal2 = false;
		let qtVal3 = false;
		let qtVal4 = false;

		if (state.searchParams.mmPrvs === '10') {
			let propI = 1;
			for (let i = strMo; i < strMo + diffMonth + 1; i++) {
				const year = strYr + Math.floor(i / 12);
				const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
				const month = (i % 12) + 1;
				const label = labelYear + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
				propI++;
				cols.push(label);
			}
		} else if (state.searchParams.mmPrvs === '20') {
			let propI = 1;
			let label;
			for (let i = strMo; i < strMo + diffMonth + 1; i++) {
				const year = strYr + Math.floor(i / 12);
				const labelYear = year.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
				const month = (i % 12) + 1;
				if (month == 1 || month == 2 || month == 3) {
					if (qtVal1 === false) {
						(label = labelYear + ' 01Qt'), cols.push(label);
						propI++;
						qtVal1 = true;
					} else {
					}
				} else if (month == 4 || month == 5 || month == 6) {
					if (qtVal2 === false) {
						(label = labelYear + ' 02Qt'), cols.push(label);
						propI++;
						qtVal2 = true;
					} else {
					}
				} else if (month == 7 || month == 8 || month == 9) {
					if (qtVal3 === false) {
						(label = labelYear + ' 03Qt'), cols.push(label);
						propI++;
						qtVal3 = true;
					} else {
					}
				} else if (month == 10 || month == 11) {
					if (qtVal4 === false) {
						(label = labelYear + ' 04Qt'), cols.push(label);
						propI++;
						qtVal4 = true;
					} else {
					}
				} else if (month == 12) {
					if (qtVal4 === false) {
						(label = labelYear + ' 04Qt'), cols.push(label);
						propI++;
					} else {
					}
					qtVal1 = false;
					qtVal2 = false;
					qtVal3 = false;
					qtVal4 = false;
				}
			}
		} else {
			let endYr = moment(endMonth).year();
			let diffYears = moment(endYr).diff(strYr);
			for (let i = strYr; i < strYr + diffYears + 1; i++) {
				const labelYear = i + `${rootGetters['commonStore/getMessage_']('QWCC001451')}`;
				let label = labelYear;
				cols.push(label);
			}
		}

		return cols;
	},
	MixedDataSet_: ({ chartList }, getters, rootState, rootGetters) => {
		// 바 스택차트 데이터셋 셋팅 ()
		const cols = [];

		const barData1 = [];
		const barData2 = [];
		const lineData = [];

		let bgColor1 = [];
		let bgColor2 = [];
		let bgColor3 = [];

		let tmpLabel = '';
		let carCd = [];
		let tmpCarCd = '';
		let newCol = {};

		//바차트
		for (let k = 0; k < chartList.length; k++) {
			barData1.push(chartList[k].saleCnt);
			barData2.push(chartList[k].clmCnt);
			lineData.push(chartList[k].clmRt);
		} //

		const barCol1 = {
			type: 'bar',
			label: `${rootGetters['commonStore/getMessage_']('QWCC001569')}`, //대상대수
			data: barData1,
			borderColor: setMixedChartBdColor(0),
			backgroundColor: setMixedChartBdColor(0)
		};

		cols.push(barCol1);

		const barCol2 = {
			type: 'bar',
			label: `${rootGetters['commonStore/getMessage_']('QWCC001568')}`, //클레임건수
			data: barData2,
			borderColor: setMixedChartBdColor(1),
			backgroundColor: setMixedChartBdColor(1)
		};

		cols.push(barCol2);

		const lineCol = {
			type: 'line',
			label: `${rootGetters['commonStore/getMessage_']('QWCC001234')}`, //불량율
			data: lineData,
			borderColor: setMixedChartBdColor(2)
		};

		cols.push(lineCol);

		return cols;
	}
};
